import React from 'react'
import Chart from 'react-apexcharts'

interface DonutChartProps {
  options: {}
  series: number[]
}

export const DonutChart2: React.FC<DonutChartProps> = ({ options, series }) => {
  return (
    <div className='app'>
      <div className='row'>
        <div className='mixed-chart'>
          <Chart options={options} series={series} type='donut' height={500} />
        </div>
      </div>
    </div>
  )
}
